/**
 * @Author fxg1997
 * @version 1.0
*/
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main style="display: flex">
        <div>
          <div class="header_right" @click="showCardNav = !showCardNav">
            <div class="title">搜索</div>
            <div>
              <transition name="from"></transition>
              <span v-show="!showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-down"></i>
              </span>
              <transition name="to"></transition>
              <span v-show="showCardNav">
                <i style="margin-right: 5px" class="el-icon-arrow-up"></i>
              </span>
            </div>
          </div>
          <div v-show="showCardNav" class="hr"></div>
          <el-collapse-transition>
            <div v-show="showCardNav">
              <div class="search">
                <span style="display: inline-block;margin-bottom: 10px;">
                  <span style="margin-right: 12px">数据源名称：</span>
                  <el-input v-model="tableParam.name" style="width: 240px" clearable placeholder="请输入" />
                </span>
                <el-button icon="el-icon-search" size="medium" class="bottom_all" @click="(tableParam.page = 1), gettableData()">查 询</el-button>
                <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
              </div>
            </div>
          </el-collapse-transition>
          <div class="hr"></div>
          <div class="card">
            <div class="card_nav">
              <div>
                <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加')">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
              </div>
              <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                  <el-link :underline="false">
                    <span class="el-icon--left">
                      <i class="iconfont iconicon_button_filtrate"></i>
                    </span>
                    筛选
                  </el-link>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item, index) in table" :key="index">
                      <el-checkbox v-model="item.status">{{
                        item.label
                        }}</el-checkbox>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div v-loading="tableLoading" class="card_info" :style="style">
              <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
                <template v-for="(item, index2) in table">
                  <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width" :fixed="item.label =='操作'?'right':false">
                    <template slot-scope="scope">
                      <span v-if="item.label == '状态'">
                        <span v-if="scope.row.enable == 0" style="color: #969799">禁用</span>
                        <span v-if="scope.row.enable == 1" style="color: #00a754">启用</span>
                      </span>
                      <div v-else-if="item.label == '操作'">
                        <el-button class="bottom_one" size="mini" @click=" updateFromDate(scope.row, '修改' )">

                          修改
                        </el-button>
                        <el-button size="mini" class="bottom_two" @click="delTable(scope.row.id)">
                          删除
                        </el-button>
                      </div>
                      <span v-else>{{ scope.row[item.prop] }}</span>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize" layout="prev, pager, next, jumper" :total="total" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="480px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="110px">
          <el-form-item prop="name">
            <span slot="label" style="color: #ff0000">数据源名称</span>
            <el-input v-model="fromDate.name" placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="dbType">
            <span slot="label" style="color: #ff0000">类型</span>
            <el-select v-model="fromDate.dbType" placeholder="请选择" @change="change(fromDate.dbType)">
              <el-option value="mysql"></el-option>
              <el-option value="oracle"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="dbUrl">
            <span slot="label" style="color: #ff0000">链接</span>
            <el-input v-model="fromDate.dbUrl" class="textarea" type="textarea" resize="none" rows="7" placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="dbAccount">
            <span slot="label" style="color: #ff0000">账号</span>
            <el-input v-model="fromDate.dbAccount" placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
          <el-form-item prop="dbPassword">
            <span slot="label" style="color: #ff0000">密码</span>
            <el-input v-model="fromDate.dbPassword" type="password" show-password placeholder="请输入" clearable>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitFromDate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import {
  queryPage,
  saveOrUpdate,
  update_status,
  get_dbdriver
} from "@/api/sync/syncDatasource.js";
export default {
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      saveOrUpdate: saveOrUpdate,
      /*表格数据*/
      table: [
        { label: "数据源名称", width: "160", prop: "name", status: true },
        { label: "链接", width: "240", prop: "dbUrl", status: true },
        { label: "类型", width: "100", prop: "dbType", status: true },
        { label: "创建时间", width: "160", prop: "createTimeStr", status: true },
        { label: "更新时间", width: "160", prop: "updateTimeStr", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "操作", width: "180", prop: "", status: true },
      ],
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        name: [{ required: true, message: "请输入数据源名称", trigger: "blur" }],
        dbUrl: [{ required: true, message: "请输入链接", trigger: "blur" }],
        dbType: [{ required: true, message: "请选择类型", trigger: "change" }],
        dbAccount: [{ required: true, message: "请输入账号", trigger: "blur" }],
        dbPassword: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      fromDate: {
        dbUrl: '',
        dbType: ''
      },
    };
  },
  created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, name: "" };
    this.gettableData();
  },
  methods: {
    async change(dbType) {
      const { data } = await get_dbdriver({ dbType: dbType })
      this.fromDate.dbUrl = data

    },
    delTable(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'bottom_all_two',
        confirmButtonClass: 'bottom_all',
        type: 'warning'
      }).then(() => {
        update_status({ id: id, status: 0 }).then(res => {
          if (res.code == 1001) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.gettableData();
          }
        })

      }).catch(() => {
      });
    },
    /*重置数据,此方法必须存在，并且方发只重置条件*/
    init() {
      this.tableParam.name = "";
      this.gettableData();
    },
    // pagessubmitFromDate() {
    //   let _this = this;
    //   _this.$refs.reffromDate.validate((valid) => {
    //     if (valid) {
    //       _this.submitFromDate();
    //     } else {
    //       return false;
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.textarea,
.el-select {
  width: 240px;
}
/*
 <el-link class="table_link" :underline="false">查看配合比</el-link>*/
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>
